module.exports = __webpack_public_path__ + "static/media/imgBM.fa8064a1.svg";